var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8086 81.5238L14.42 80.6676L43.3439 25.7859L43.405 25.205L30.6547 1.25551C29.5865 -0.750684 26.5792 -0.243448 26.2286 2.00233L13.8086 81.5238Z",
    fill: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1693 80.871L14.6318 79.9691L43.2526 25.6624L30.5342 1.61554C29.4772 -0.369637 26.793 0.136426 26.4461 2.35868L14.1693 80.871Z",
    fill: "#303030"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7 43.3205L62.1935 33.5977L52.6973 15.4693C51.7958 13.7533 49.2788 13.7484 48.3869 15.4693L43.3135 25.1453V25.9694L52.7 43.3205Z",
    fill: "#C8C8C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5307 42.9153L61.7601 33.463L52.5307 15.8885C51.6543 14.2203 49.5252 14.0455 48.658 15.7186L43.5577 25.5445L43.4052 26.0468L52.5307 42.9153Z",
    fill: "#C8C8C8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8086 81.5238L14.0857 81.2452L15.0927 80.8359L52.1036 43.9626L52.5725 42.6862L43.3398 25.0925L13.8086 81.5238Z",
    fill: "#C8C8C8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8854 100.12L87.381 81.4391L77.8158 22.5299C77.5166 20.6868 75.2554 19.9581 73.9362 21.2797L13.8086 81.5238L47.1121 100.118C49.2168 101.293 51.7801 101.294 53.8854 100.12Z",
    fill: "#C8C8C8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0808 81.2824L77.5882 22.8205C77.2913 20.9914 75.4109 20.2345 74.1018 21.546L14.1799 81.4094L47.1176 99.8197C49.2064 100.986 51.7503 100.987 53.8395 99.8214L87.0808 81.2824Z",
    fill: "#303030"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8854 99.5695C51.7801 100.744 49.2168 100.743 47.1121 99.5679L14.0768 81.2405L13.8086 81.5238L47.1121 100.118C49.2168 101.293 51.7801 101.294 53.8854 100.12L87.381 81.4391L87.299 80.9344L53.8854 99.5695Z",
    fill: "#E7E7E7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.7e0831caed4ea6405e28bb7f63631a64.svg";
export { ForwardRef as ReactComponent };